import { Pipe, PipeTransform, inject } from '@angular/core';
import { OptionService } from '@app/services/option.service';

@Pipe({
    name: 'listByType',
    pure: false,
})
export class ListByTypePipe implements PipeTransform {
    private readonly optionService = inject(OptionService);

    public transform(key: string): any[] {
        return this.optionService.getListByType(key);
    }
}
